import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ResponsibleGaming = () => {
  const location = useLocation();
  return (
    <>
      {location.pathname === "/responsible-gaming" && (
        <Helmet>
          <title>
            Vikinglotto: Best Licensed Lottery with New Responsible Gaming
            Practices
          </title>
          <meta
            name="description"
            content="Vikinglotto promotes the best licensed gaming practices with new responsible gaming features. Play safely and enjoy a secure, regulated lottery experience."
          />
          <link
            rel="canonical"
            href={`https://lottolegenda.com${location.pathname}`}
          />
        </Helmet>
      )}
      <main>
        <section className="pad pad-top flex lottolegenda-legal">
          <h1>Responsible Gaming</h1>
          <p>
            At Vikinglotto, we believe playing the lottery should always be fun,
            safe, and under control. Our commitment to responsible gaming means
            helping players make informed choices and offering tools for
            self-regulation.
          </p>
          <p className=" t-21 mg-bot">Player Tips for Healthy Play</p>
          <ul>
            <li>Set a budget before you play — never chase losses</li>
            <li>Remember: playing the lottery is not a way to make money</li>
            <li>Only play for entertainment</li>
            <li>Take breaks if you feel frustrated or impulsive</li>
            <li>Never borrow money to play</li>
          </ul>
          <h2>Limits & Self-Control Tools</h2>
          <p className=" t-21 mg-bot">
            Each national lottery operator offers tools to support responsible
            gaming:
          </p>
          <ul>
            <li>Spending limits per day, week, or month</li>
            <li>Session time reminders</li>
            <li>Self-assessment tests</li>
            <li>Temporary or permanent self-exclusion options</li>
            <li>Transaction history tracking</li>
          </ul>
          <h2>Need Help? You’re Not Alone</h2>
          <p className=" t-21 mg-bot">
            If you or someone you know is experiencing problems related to
            gambling, professional help is available:
          </p>
          <ul>
            <li>
              GamCare (UK):{" "}
              <Link to="https://www.gamcare.org.uk/">www.gamcare.org.uk</Link>
            </li>
            <li>
              BeGambleAware:{" "}
              <Link to="https://www.begambleaware.org">
                www.begambleaware.org
              </Link>
            </li>
            <li>
              StopSpillet (Denmark): 
              <Link to="https://www.stopspillet.dk">www.stopspillet.dk</Link>
            </li>
            <li>
              Peluuri (Finland): 
              <Link to="https://www.peluuri.fi">www.peluuri.fi</Link>
            </li>
            <li>
              Responsible Gambling Council (International): 
              <Link to="https://www.responsiblegambling.org/">
                www.responsiblegambling.org
              </Link>
            </li>
          </ul>
        </section>
      </main>
    </>
  );
};

export default ResponsibleGaming;
